import React from 'react';
import { Section } from './ui/Section';
const costs = [{
  sin: '3 horas de planificación × 40 semanas',
  real: '120 horas de tu vida por año'
}, {
  sin: 'Informes sin banco de frases',
  real: 'Domingos de diciembre frente a la hoja en blanco'
}, {
  sin: 'Material de efemérides buscado en Google',
  real: 'Actos improvisados sin coherencia pedagógica'
}, {
  sin: 'Sala sin recursos visuales pensados',
  real: 'Caos diario que vos tenés que resolver en el momento'
}, {
  sin: 'Protocolos de crisis inexistentes',
  real: 'Pánico cuando algo sale mal'
}, {
  sin: 'El mismo ciclo el próximo año',
  real: 'El agotamiento que ya conocés'
}];
export const CostOfInaction: React.FC = () => {
  return <Section className="bg-brand-card/30" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-12" data-id="element-36">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        {/* Desktop table */}
        <div className="hidden md:block overflow-hidden mb-12 rounded-2xl border border-brand-card-border" data-id="element-37">
          <table className="w-full text-left border-collapse" data-id="element-38">
            <thead data-id="element-39">
              <tr className="bg-brand-card border-b border-brand-card-border" data-id="element-40">
                <th className="p-6 font-bold text-gray-400 w-1/2" data-id="element-41">
                  Sin Megapack
                </th>
                <th className="p-6 font-bold text-white w-1/2" data-id="element-42">Costo real</th>
              </tr>
            </thead>
            <tbody data-id="element-43">
              {costs.map((row, i) => <tr key={i} className="border-b border-brand-card-border/50 hover:bg-brand-card/50 transition-colors" data-id="element-44">
                  <td className="p-6 text-gray-400" data-id="element-45">{row.sin}</td>
                  <td className="p-6 text-red-400 font-bold" data-id="element-46">{row.real}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile stacked cards */}
        <div className="md:hidden space-y-4 mb-12" data-id="element-47">
          {costs.map((row, i) => <div key={i} className="bg-brand-card border border-brand-card-border rounded-2xl p-5" data-id="element-48">
              <div className="mb-3" data-id="element-49">
                <span className="block text-xs font-bold text-gray-400 uppercase tracking-wide mb-0.5" data-id="element-50">
                  Sin Megapack
                </span>
                <span className="text-gray-300 text-sm" data-id="element-51">{row.sin}</span>
              </div>
              <div data-id="element-52">
                <span className="block text-xs font-bold text-white uppercase tracking-wide mb-0.5" data-id="element-53">
                  Costo real
                </span>
                <span className="text-red-400 text-sm font-bold" data-id="element-54">
                  {row.real}
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center text-xl md:text-2xl font-bold text-white space-y-2" data-id="element-55">
          <p data-id="element-56">El próximo domingo puede ser diferente.</p>
          <p className="text-brand-green" data-id="element-57">
            "El año que viene podés empezar con todo listo desde el primer día."
          </p>
        </div>
      </div>
    </Section>;
};